module.exports = __webpack_public_path__ + "media/bootstrap-icons/collection-play-fill-bbcb2125.svg";